import React from 'react'

import {
  SocialShareWrapper,
  SocialShareContainer,
  SocialShareTextWrapper,
  SocialShareTitle,
  SocialShareText,
  SocialButtonsWrapper,
  ShareEyeBg,
  ShareBox,
  ShareBoxTitle,
  ShareBoxBtn
} from './styled'

import EyeOpenedNoBg from '../../../images/eye-opened-main-page.svg'

const siteBaseURL =
  typeof window !== 'undefined' ? window.location.origin : null

const SocialShareSection = () => {
  return (
    <SocialShareWrapper>
      <SocialShareContainer>
        <SocialShareTextWrapper>
          <SocialShareTitle>Share to the others</SocialShareTitle>
          <SocialShareText>
            Let’s spread the idea and envolved more people to the cause.
          </SocialShareText>
        </SocialShareTextWrapper>
        <SocialButtonsWrapper>
          <ShareEyeBg src={EyeOpenedNoBg} />
          <ShareBox>
            <ShareBoxTitle>Share to Facebook</ShareBoxTitle>
            <ShareBoxBtn
              href={`http://www.facebook.com/sharer.php?u=${siteBaseURL}`}
              target='_blank'
            >
              Facebook
            </ShareBoxBtn>
          </ShareBox>
          <ShareBox>
            <ShareBoxTitle>Share to Twitter</ShareBoxTitle>
            <ShareBoxBtn
              href={`http://twitter.com/home?status=The%20Change:%20${siteBaseURL}`}
              target='_blank'
            >
              Twitter
            </ShareBoxBtn>
          </ShareBox>
        </SocialButtonsWrapper>
      </SocialShareContainer>
    </SocialShareWrapper>
  )
}

export default SocialShareSection
